// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__zfhso","newChat":"Sidebar_newChat__n9LF4","chatHistory":"Sidebar_chatHistory__IBVXV"};